import { render } from "./Elevator.vue?vue&type=template&id=013b51df"
import script from "./Elevator.vue?vue&type=script&lang=js"
export * from "./Elevator.vue?vue&type=script&lang=js"

import "./Elevator.vue?vue&type=style&index=0&id=013b51df&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__